import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { bookData } from "../../Types/Types";

export const getBooks = createAsyncThunk(
  "books/getBooks",
  async (data, thunkApi) => {
    try {
      const response = await axios.get<bookData[]>(
        "https://api.npoint.io/2ecd3b3b6865d2a38168"
      );

      return response.data;
    } catch (error: any) {
      const message = error.message;
      return thunkApi.rejectWithValue(message);
    }
  }
);
